import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollToTop = () => {
  // Try scrollIntoView on anchor element
  const anchor = document.getElementById('page-top-anchor');
  if (anchor) {
    anchor.scrollIntoView({ behavior: 'instant', block: 'start' });
  }
  // Fallback: scroll window and document
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate scroll
    scrollToTop();
    // Delayed scroll to ensure DOM is ready
    const timeoutId = setTimeout(scrollToTop, 0);
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};
